import { FormControl } from '@angular/forms';
import { each } from 'lodash';

function otherSubscribeValueChanges(
  control: FormControl,
  subscriptions: any,
  keys: string[],
) {
  each(keys, (key) => {
    let _control = control.parent?.get(key);
    if (!_control) {
      _control = control.root?.get(key);
    }
    if (!subscriptions[key] && _control) {
      subscriptions[key] = _control.valueChanges.subscribe(() => {
        setTimeout(() => {
          control?.updateValueAndValidity({ emitEvent: false });
        });
      });
    }
  });
}

function otherSubscribeValueChangesEmit(
  control: FormControl,
  subscriptions: any,
  keys: string[],
) {
  each(keys, (key) => {
    const _control = control.root.get(key);
    if (!subscriptions[key] && _control) {
      subscriptions[key] = _control.valueChanges.subscribe(() => {
        setTimeout(() => {
          control?.updateValueAndValidity({ emitEvent: true });
        });
      });
    }
  });
}

export function callbackValidator(
  callback: (control: FormControl) => {
    [key: string]: boolean;
  } | null,
  controlKeys: string[] = [],
) {
  const subscriptions = {};
  return (control: FormControl) => {
    otherSubscribeValueChangesEmit(control, subscriptions, controlKeys);
    const result = callback(control);
    return result ? result : null;
  };
}

export function callbackRequired(
  callback: (() => boolean) | ((control: FormControl) => boolean),
  controlKeys: string[] = [],
) {
  const subscriptions = {};
  return (control: FormControl) => {
    otherSubscribeValueChanges(control, subscriptions, controlKeys);
    return !control.value && callback(control) ? { required: true } : null;
  };
}

export function callbackOneRequired(
  callback: () => boolean,
  controlKeys: string[] = [],
) {
  const subscriptions = {};
  return (control: FormControl) => {
    otherSubscribeValueChanges(control, subscriptions, controlKeys);
    return !Object.keys(control.value).find(
      (value: any) => !!control.value[value],
    ) && callback()
      ? { required: true }
      : null;
  };
}
